import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_PAYMENT_REMINDERS_LIST: string = typeCreatorV2(
  'PaymentReminderReducer',
  'SetPaymentRemindersList'
);

export const SET_PAYMENT_REMINDERS_TO_GENERATE: string = typeCreatorV2(
  'PaymentReminderReducer',
  'SetPaymentRemindersToGenerate'
);
